import { render } from "./AnalysisAgentChat.vue?vue&type=template&id=071054b8&scoped=true"
import script from "./AnalysisAgentChat.vue?vue&type=script&lang=js"
export * from "./AnalysisAgentChat.vue?vue&type=script&lang=js"

import "./AnalysisAgentChat.vue?vue&type=style&index=0&id=071054b8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-071054b8"]])

export default __exports__